import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface SidebarLinkProps {
  name: string;
  path?: string;
  icon?: ReactNode;
  isActive?: boolean;
  isExpanded?: boolean;
  onClick?: () => void;
  onAction?: () => void;
  children?: ReactNode;
  className?: string;
}

const SidebarLink = ({ name, path, icon, isActive, isExpanded, onClick, onAction, children, className = '' }: SidebarLinkProps) => {
  const content = (
    <>
      {icon && <span className="sidebar-link-icon">{icon}</span>}
      {name}
    </>
  );

  return (
    <li className={`sidebar-link ${isActive ? 'selected' : ''} ${isExpanded ? 'expanded' : ''} ${className}`.trim()}>
      {path ? (
        <Link to={path} onClick={onClick}>
          {content}
        </Link>
      ) : (
        <button type="button" onClick={onAction ?? onClick}>
          {content}
        </button>
      )}
      {children}
    </li>
  );
};

export default SidebarLink;
